import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Profiles } from "../utils/enums/profiles";

export const profilesLogOutGuardActivate : CanActivateFn = (route, state)  =>{
  const router = inject(Router);

  if(localStorage.getItem('token')){
    if(localStorage.getItem('user')){
       const user = JSON.parse(localStorage.getItem('user')!)
      if(user.profile === Profiles.ADMIN || user.profile === Profiles.CUSTOMER){
        return true
      }
      router.navigate([`/platform/${user.urlHome}`])
      return false;
    }
  }

  return true;
}
